import { H2, Text } from '@ui';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import styles from './CompanyDetails.module.css';
import profileMessages from '../Profile.messages';
import { validateCompanyForm } from './formValidation/companyFormValidationHandler';
import { AnnualProfitQuestion } from './questions/AnnualProfitQuestion';
import CompanyNameQuestion from './questions/CompanyNameQuestion';
import { CompanyTypeQuestion } from './questions/CompanyTypeQuestion';
import IndustryQuestion from './questions/IndustryQuestion';
import { TradingFromQuestion } from './questions/TradingFromQuestion';
import { TradingNameQuestion } from './questions/TradingNameQuestion';
import TurnoverQuestion from './questions/TurnoverQuestion';
import WebsiteQuestion from './questions/WebsiteQuestion';
import { getCountry } from '../../../iwIntlProvider/CountryProvider';

const formConfiguration = {
    form: 'CompanyDetails',
    onSubmit: (values, dispatch, props) => props.companyFormValidate(values),
    validate: (values, props) => props.companyFormValidate(values),
    enableReinitialize: true
};

const mapStateToProps = ({ profile }) => ({
    ...profile,
    companyFormValidate: (props) => validateCompanyForm(profile, props),
    initialValues: {
        companyName: profile.company_name,
        companyNumber: profile.company_number,
        tradingName: profile.trading_name,
        companyType: profile.companyType.label,
        website: profile.website,
        annualTurnover: profile.annual_turnover,
        annualProfit: profile.annual_profit,
        tradingFrom: profile.trading_from,
        industry: profile.industry
    }
});

const CompanyDetails = ({ companyType, onChange }) => {
    const renderQuestions = () => {
        const soleTrader = companyType.value === 'sole_trader';
        if (soleTrader) {
            return (
                <>
                    <TradingNameQuestion onChange={onChange} />
                    <CompanyTypeQuestion onChange={onChange} />
                    <IndustryQuestion onChange={onChange} />
                    <WebsiteQuestion onChange={onChange} />
                    <TurnoverQuestion onChange={onChange} />
                    {getCountry() === 'UK' && (
                        <AnnualProfitQuestion onChange={onChange} />
                    )}
                    <TradingFromQuestion onChange={onChange} />
                </>
            );
        }

        return (
            <>
                <CompanyNameQuestion onChange={onChange} />
                <CompanyTypeQuestion onChange={onChange} />
                <WebsiteQuestion onChange={onChange} />
                <TurnoverQuestion onChange={onChange} />
                <TradingFromQuestion onChange={onChange} />
            </>
        );
    };

    return (
        <div className="space-y-xl">
            <div>
                <H2>
                    <FormattedMessage
                        {...profileMessages.companyDetailsTitle}
                    />
                </H2>
                <Text className="mt-xs">
                    <FormattedMessage
                        {...profileMessages.companyDetailsSubtitle}
                    />
                </Text>
            </div>
            <form className={styles.detailsFormWrapper} autoComplete="off">
                <div className={styles.detailsFormQuestions}>
                    {renderQuestions()}
                </div>
            </form>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(
    reduxForm(formConfiguration)(CompanyDetails)
);
